"use client";
import { cn, dayjs, formatPrettyValue } from "utils";
import React, { useMemo, useContext } from "react";
import { PageFooter } from "../Footer";
import { SuccessModal } from "./SuccessModal";
import { useConnect, useSeasonConfig, useSeasonDetail, useClaim } from "@/hooks";
import { claimStatusEum, settleStatusEum } from "@/const";
import { Spinner } from "../Icon";
import { PageHeader } from "../Header";
import { GlobalContext } from "@/context";

export const HomeVerified = () => {
  const { loggingIn } = useContext(GlobalContext);
  const { onConnect, onDisconnect, address, loading } = useConnect();
  const { seasonConfig, isConfigLoading } = useSeasonConfig();
  const { id, settleStatus: curSettleStatus, previousSettleStatus, endTime } = seasonConfig || {};
  let curSeasonId = id - 1;
  if(curSettleStatus === 0 && previousSettleStatus == 2) {
    curSeasonId = id;
  }
  const { achievementDetail, isFetching, refetch } = useSeasonDetail({seasonId: curSeasonId});
  console.log("line10", seasonConfig, achievementDetail);
  const { settleStatus, claimStatus, owoCount, claimEndTime, claimStartTime } = achievementDetail || {};
  const { onClaim: onClaimButter, hash, claiming, isSuccess, setIsSuccess } = useClaim();
  const onClose = () => {
    setIsSuccess(false);
    refetch();
  }
  const claimOwoTextMap = {
    [claimStatusEum.CLAIMED]: "Claimed",
    [claimStatusEum.UN_CLAIMED]: "Claim $BUTTER",
    [claimStatusEum.UN_STARTED]: `Claim on ${dayjs(claimStartTime).utc().format("MMM D, HH:mm")} UTC`,
    [claimStatusEum.EXPIRED]: "Expired",
  } as any;

  const claimMessage = claimStatus === claimStatusEum.EXPIRED ? "Claim period ended" : `Claim before ${dayjs(claimEndTime).utc().format("MMM D, YYYY HH:mm:ss")} UTC`;

  const owoValue = useMemo(() => {
    const value = {
      0: '???????',
      1: 'Calculating…',
      2: formatPrettyValue(owoCount?.toString())
    } as any;
    const owoValue = value[settleStatus] || '???????';
    return owoValue;
  }, [settleStatus]);
  const onClaim = async () => {
    const res = await onClaimButter(seasonConfig?.owoTokenAddress)
  }
  return (
    <>
      <PageHeader className={cn('fixed z-[200] w-screen')} onConnect={onConnect} onDisconnect={onDisconnect} loading={loading} address={address as `0x${string}`}/>
      <div
        className={cn("h-full pb-[288px] relative")}
      >
        <div className="relative bg-no-repeat bg-[url('/assets/airdropBg.webp')] bg-cover bg-[center_bottom_0] h-[517px]">
          <div className="absolute -bottom-[40px] left-[50%] -translate-x-2/4 bg-[url('/assets/airdropDate.webp')] bg-no-repeat bg-cover w-[660px] h-[447px] flex items-center flex-col pt-[190px] pl-8">
            <p className="text-sm text-Content-Primary font-oswald font-bold h-[21px]">{!!curSeasonId ? `· Season ${curSeasonId} ·`: ''}</p>
            <div className="text-4xl font-luckiestGuy font-bold mb-1 text-center">$butter airdrop</div>
            <div className="px-3 pt-2 bg-Content-Primary rounded-[6px] text-Primitives-Yellow-500 font-luckiestGuy text-[44px] leading-[52px] overflow-hidden mb-1 min-w-[124px] text-center">{loggingIn ? owoValue : '???????'}</div>
            <p className="text-xs text-Content-Primary font-oswald font-bold">{
              !!achievementDetail && !!loggingIn ? (settleStatus !== settleStatusEum.SETTLED ? `Results on ${dayjs(endTime).utc().format("MMM D, YYYY HH:mm:ss")}UTC` : claimMessage)  : "" }</p>
          </div>
        </div>
        <div className="flex-col flex items-center mt-[40px]">
          <p className="text-base text-Accent-Inverse-Backup3 font-bold font-oswald">$BUTTER will be sent on BNB Chain</p>
          <p className="text-base text-Accent-Inverse-Backup3 font-oswald">To claim $BUTTER, connect the wallet with the same address linked to your BreadnButter account.</p>
          {loggingIn ? <button className={cn("btn-lg font-oswald btn-fill-green font-bold rounded-[20px] min-w-[360px] my-6", {
            "btn-fill-gray cursor-not-allowed text-Content-Disabled" : claimStatus !== claimStatusEum.UN_CLAIMED,
          })} onClick={onClaim} disabled={claimStatus !== claimStatusEum.UN_CLAIMED || isFetching || isConfigLoading || loading || claiming}>
            {isFetching || isConfigLoading || loading || claiming ? (
              <Spinner
                className={cn("fill-Content-Primary w-5 h-5 animate-spin")}
              />
            ) : (
              claimOwoTextMap[claimStatus] || 'Claim $BUTTER'
            )}
          </button> : <button className={cn("btn-lg font-oswald btn-fill-green font-bold rounded-[20px] min-w-[360px] my-6")} onClick={onConnect}>
                {isFetching || isConfigLoading || loading ? (
                  <Spinner
                    className={cn("fill-Content-Primary w-5 h-5 animate-spin")}
                  />
                ) : 'Claim $BUTTER'}
              </button>}
          
        </div>
        <PageFooter className='w-screen absolute bottom-0'/>
        <SuccessModal visible={isSuccess} close={onClose} hash={hash as string}/>
      </div>
    </>
  );
};

